export default __webpack_public_path__ + "static/media/ironmain.4aaaf44c.png";